export const SET_EXIT_SURVEY_URL = "SET_EXIT_SURVEY_URL";

export function setExitSurveyUrlFromType(payload) {
  return async dispatch => {
    await dispatch({
      type: SET_EXIT_SURVEY_URL,
      payload: payload
    });
  };
}
